export interface AppContainerState {
  user: User | null;
  selectedAccount?: Account;
}

export interface User {
  id?: string;
  b2CId: string;
  socialNumber?: string;
  firstName: string;
  lastName: string;
  fullName?: string;
  gender?: Gender;
  birthDate?: Date | string;
  email: string;
  phone?: string;
  status?: ActivityStatus;
  role?: number;
  enrolled?: Date | string;
  groupIds?: string[];
  avatarId?: string;
  bodyWeight?: number;
  bodyWeightLbl?: number;
  bodyWeightUpdated?: Date | string;
  country?: string;
  dominantArm?: LeftRight;
  dominantLeg?: LeftRight;
  fid?: string;
  pid?: string;
  height?: number;
  heightInc?: number;
  position?: string;
  sport?: string;
  checked?: boolean;
}

export enum Gender {
  Male = 1,
  Female = 2,
}

export enum LeftRight {
  None = 0,
  Left = 1,
  Rigth = 2,
}

export enum ActivityStatus {
  Active = 0,
  Inactive = 1,
}

export enum Roles {
  Undefined = 0,
  User = 1,
  SiteOwner = 2,
  Administrator = 4,
  SpaceOwner = 8,
  SpaceAdministrator = 16,
}

export interface Claims {
  oid: string;
  family_name: string;
  given_name: string;
  extension_MusclelabRole: number;
  emails: string[];
  extension_BirthofDate: string;
  extension_Bodyweight: number;
  extension_Height: number;
  extension_PID: string;
  extension_sex: string;
  country?: string;
  newUser?: boolean;
}

export interface UserResponse {
  items: User[];
  total: number;
}

export interface DropdownResponse {
  id: string;
  name: string;
}

export interface Account {
  id: string;
  name: string;
  role: Roles;
  type: AccountType;
  paid: boolean;
}

export enum AccountType {
  PERSONAL = 'PERSONAL',
  SPACE = 'SPACE',
}

export interface ListResponse<T> {
  items: T[];
  total: number;
}

export interface Code {
  id: string;
  personId?: string;
  spaceId?: string;
  groupIds?: string[];
  memberIds?: string[];
  expired: string | Date;
  timeLost?: string;
  intervalId?: NodeJS.Timeout;
}

export type Unwrap<T> = T extends Promise<infer U>
  ? U
  : T extends (...args: any) => Promise<infer U>
  ? U
  : T extends (...args: any) => infer U
  ? U
  : T;
